import { render } from "./Icash.vue?vue&type=template&id=274c670f&scoped=true"
import script from "./Icash.vue?vue&type=script&lang=js"
export * from "./Icash.vue?vue&type=script&lang=js"

import "./Icash.vue?vue&type=style&index=0&id=274c670f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274c670f"]])

export default __exports__